import { io } from "socket.io-client";
import { getConfig } from "./config/config";
import jwtDecode from "jwt-decode";

const config = getConfig();
// "undefined" means the URL will be computed from the `window.location` object
const URL = process.env.NODE_ENV === "production" ? undefined : config.ioServer;

const jwt = localStorage.getItem("token");
const decoded = jwt ? jwtDecode(jwt) : null;

var params = "";

if (!decoded) {
} else {
  params = "userId=" + decoded.user._id + "&empresaId=" + decoded.user.empresa;
}

export const socket = io(URL, { query: params });
